import { IButtonStyles } from '@fluentui/react';
import { ITheme, mergeStyleSets } from '@fluentui/react/lib/Styling';
import { memoizeFunction } from '@fluentui/react/lib/Utilities';

import { buttonIconWidth, buttonPadding } from '@1js/acui-button';
import {
  buttonBorderWidth,
  getModernUxExperimentPreference,
  getStandardControlSemanticColorsWithTheme,
} from '@1js/acui-common';
import { isThemingEnabled } from '@1js/acui-theme';

import { ribbonModeStylingConstantsSLR } from '../../ribbonStylingConstants';

export const overflowButtonWidth = buttonIconWidth + 2 * buttonPadding + 2 * buttonBorderWidth;
export const ribbonOverflowSetItemContainerClass = 'ribbonOverflowItem';

export interface RibbonControlGroupSLRClassNames {
  root: string;
}

export const getRibbonControlGroupSLRClassNames = memoizeFunction(
  (): RibbonControlGroupSLRClassNames => {
    return mergeStyleSets({
      root: {
        display: 'inline-block',
        verticalAlign: 'top',
      },
    });
  }
);

export const getOverflowLauncherStyles = memoizeFunction(
  (theme: ITheme): IButtonStyles => {
    const semanticColors = getStandardControlSemanticColorsWithTheme(theme);
    return {
      icon: {
        fill: isThemingEnabled() ? semanticColors.textColor : '#444444',
      },
    };
  }
);

export const getOverflowSetItemStyles = memoizeFunction(() => {
  return {
    root: [
      getModernUxExperimentPreference() && {
        alignItems: 'center',
        height: ribbonModeStylingConstantsSLR.bottomBarHeight,
      },
    ],
    item: ribbonOverflowSetItemContainerClass,
  };
});
